/**
 * id: Used by the ListDropdown component as the default for when we pick the form and sync to the API server.
 * name: Used by the ListDropdown component as the value to display to the user.
 */
export const citizenshipStatuses = [
    {id: 'us_citizen', name: 'US Citizen'},
    {id: 'resident_alien', name: 'Residential Alien'},
];
